// extracted by mini-css-extract-plugin
export default {"label":"Contact_label__Yv-BZ","contactItems":"Contact_contactItems__TKxmC"};